import DashboardLayout from '@/views/Layout/DashboardLayout.vue'
import AuthLayout from '@/views/Pages/AuthLayout.vue'
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue'

import store from '@/store'

// Issues pages
const Issues = () => import('@/views/Issues/IssuesList.vue')
const IssuesForm = () => import('@/views/Issues/IssuesForm.vue')
const IssuesDetails = () => import('@/views/Issues/IssuesDetails.vue')

// Issues pages
const IssuesTypes = () => import('@/views/IssuesTypes/IssuesTypesList.vue')
const IssuesTypesForm = () => import('@/views/IssuesTypes/IssuesTypesForm.vue')
const IssuesTypesFormEdit = () =>
  import('@/views/IssuesTypes/IssuesTypesFormEdit.vue')

// DashboardBocapio pages
const DashboardBocapio = () =>
  import('@/views/DashboardBocapio/DashboardBocapio.vue')

// Products
const ProductsList = () => import('@/views/Products/ProductsList.vue')

// Reports
const SalesReport = () => import('@/views/Reports/SalesReport.vue')
const VisitsReport = () => import('@/views/Reports/VisitsReport.vue')
const Booking = () => import('@/views/Reports/Booking.vue')

// Configurations
const Configurations = () =>
  import('@/views/Configurations/Configurations.vue')

// Calendar
const Calendar = () => import('@/views/Calendar/Calendar.vue')
// Charts
const Charts = () => import('@/views/Charts.vue')

// Components pages
const Buttons = () => import('@/views/Components/Buttons.vue')
const Cards = () => import('@/views/Components/Cards.vue')
const GridSystem = () => import('@/views/Components/GridSystem.vue')
const Notifications = () => import('@/views/Components/Notifications.vue')
const Icons = () => import('@/views/Components/Icons.vue')
const Typography = () => import('@/views/Components/Typography.vue')

// Dashboard pages
const DashboardTemplete = () => import('@/views/Dashboard/Dashboard.vue')
const IndexPage = () => import('@/views/Dashboard/IndexPage.vue')
const AlternativeDashboard = () => import('@/views/Dashboard/AlternativeDashboard.vue')

const Widgets = () => import('@/views/Widgets.vue')

// Forms pages
const FormElements = () => import('@/views/Forms/FormElements.vue')
const FormComponents = () => import('@/views/Forms/FormComponents.vue')
const FormValidation = () => import('@/views/Forms/FormValidation.vue')

// Maps pages
const GoogleMaps = () => import('@/views/Maps/GoogleMaps.vue')
const VectorMaps = () => import('@/views/Maps/VectorMaps.vue')

// Pages
const User = () => import('@/views/Pages/UserProfile.vue')
const Pricing = () => import('@/views/Pages/Pricing.vue')
const TimeLine = () => import('@/views/Pages/TimeLinePage.vue')
const userLogin = () => import('@/views/Pages/userLogin.vue')
const userLogout = () => import('@/views/Pages/userLogout.vue')
const ForgotPassword = () => import('@/views/Pages/ForgotPassword.vue')
const ResetPassword = () => import('@/views/Pages/ResetPassword.vue')
const Home = () => import('@/views/Pages/Home.vue')
const userRegister = () => import('@/views/Pages/userRegister.vue')
const ReservaExpressa = () => import('@/views/ReservaExpressa/ReservaExpressaPage.vue')
const Trafx = () => import('@/views/Trafx/TrafxPage.vue')
const Lock = () => import('@/views/Pages/Lock.vue')
const DetalhesdaReserva = () => import('@/views/Operacao/DetalhesdaReserva.vue')
const BookingList = () => import('@/views/Operacao/BookingList.vue')

// TableList pages
const RegularTables = () => import('@/views/Tables/RegularTables.vue')
const SortableTables = () => import('@/views/Tables/SortableTables.vue')
const PaginatedTables = () => import('@/views/Tables/PaginatedTables.vue')

const Financeiro = () => import('@/views/Financeiro/Financeiro.vue')
const Clients = () => import('@/views/Clients/Clients.vue')
const ClientServiceMonitor = () => import('@/views/Clients/serviceMonitor.vue')
const Agents = () => import('@/views/Agents/Agents.vue')
const AgentSelector = () => import('@/views/Agents/AgentSelector.vue')
const AgentLoader = () => import('@/views/Agents/AgentLoader.vue')
const NotaFiscal = () => import('@/views/NotaFiscal/NotaFiscal.vue')
const Operacao = () => import('@/views/Operacao/Operacao.vue')
const defaultPath = '/dashboard/index'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters['auth/isAuthenticated']) {
    next('/login')
    return
  }

  let roles = store.getters['auth/roles']
  let foundedRoles = []

  for (var role in roles) {
    foundedRoles = roles[role].filter((menu) => {
      return `/${menu.controller}/${menu.action}` === to.path
    })
    if(Object.keys(foundedRoles).length > 0){
      break;
    }
  }

  if( Object.keys(foundedRoles).length == 0 && to.path != defaultPath && process.env.NODE_ENV == "production"){
    next('/dashboard')
  }else{
    next()
  }
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/isAuthenticated']) {
    next('/loading')
    return
  }
  next()
}

const componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  name: 'Components',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'cards',
      name: 'Cards',
      component: Cards
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }
  ]
}

const DashboardBocapioMenu = {
  path: '/dashboard',
  component: DashboardLayout,
  redirect: '/dashboard/index',
  beforeEnter: ifNotAuthenticated,
  name: 'DashboardLayout',
  children: [
    {
      path: 'index',
      name: 'Dashboard index',
      component: DashboardBocapio
    }
  ]
}

const IssuesMenu = {
  path: '/issues',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  meta: { issuesPermissions: true },
  redirect: '/issues/index',
  name: 'Menu Requerimentos',
  children: [
    {
      path: 'index',
      name: 'Lista Requerimentos',
      component: Issues
    },
    {
      path: 'add',
      name: 'Formulario Requerimento',
      component: IssuesForm
    },
    {
      path: 'details',
      name: 'Issues Details',
      component: IssuesDetails
    }
  ]
}

const ConfigurationsMenu = {
  path: '/configurations',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  redirect: '/configurations/index',
  name: 'Configurations',
  children: [
    {
      path: 'index',
      name: 'DashboardConfig',
      component: Configurations
    },
    {
      path: 'issuesTypes/index',
      meta: { issuesPermissions: true },
      name: 'Tipos Requerimentos',
      component: IssuesTypes
    },
    {
      path: 'issuesTypes/add',
      meta: { issuesPermissions: true },
      name: 'Formulario Tipo',
      component: IssuesTypesForm
    },
    {
      path: 'issuesTypes/edit',
      meta: { issuesPermissions: true },
      name: 'Editar Tipo',
      component: IssuesTypesFormEdit
    }
  ]
}

const ProductsMenuLabel = 'Produtos'
const ProductsMenu = {
  path: '/products',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  redirect: '/products/index',
  name: 'ProductsMenu',
  children: [
    {
      path: 'index',
      name: currentUserManuName('/products/index') || ProductsMenuLabel,
      component: ProductsList
    }
  ]
}

const OperationMenu = {
  path: '/operation',
  component: DashboardLayout,
 beforeEnter: ifNotAuthenticated,
//  redirect: '/operation/index',
  name: 'OperationMenu',
  children: [
    {
      path: 'index',
      name: 'Operation Index',
      component: Operacao
    },
    {
      path: 'booking-list',
      name: 'Booking List',
      component: BookingList,
    }
  ]
}

const NotaFiscalMenu = {
  path: '/nf',
  component: DashboardLayout,
  redirect: '/nf/index',
  beforeEnter: ifNotAuthenticated,
  name: 'NotaFiscalMenu',
  children: [
    {
      path: 'index',
      name: 'Nota Fiscal Index',
      component: NotaFiscal
    }
  ]
}

const FinancialMenu = {
  path: '/financial',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  redirect: '/financial/index',
  name: 'FinancialMenu',
  children: [
    {
      path: 'index',
      name: 'Financial Index',
      component: Financeiro
    }
  ]
}

const ClientsMenuLabel = 'Clientes'
const ClientsMenu = {
  path: '/clients',
  component: DashboardLayout,
  redirect: '/clients/index',
  beforeEnter: ifNotAuthenticated,
  // name: currentUserManuName('/clients/index') || ClientsMenuLabel,
  children: [
    {
      path: 'index',
      name: currentUserManuName('/clients/index') || ClientsMenuLabel,
      component: Clients
    }
  ]
}

const ClientServiceMonitorMenu = {
  path: '/clients',
  component: DashboardLayout,
  redirect: '/clients/services',
  beforeEnter: ifNotAuthenticated,
  children: [
    {
      path: 'services',
      name: 'Acompanhamento',
      component: ClientServiceMonitor
    }
  ]
}

const AgentsMenuLabel = 'Agentes'
const AgentsMenu = {
  path: '/agents',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  redirect: '/agents/index',
  children: [
    {
      path: 'index',
      name: currentUserManuName('/agents/index') || AgentsMenuLabel,
      component: Agents
    }
  ]
}

const ReservaExpressaMenuLabel = 'Reserva Expressa'
const ReservaExpressaMenu = {
  path: '/booking',
  component: ReservaExpressa,
  name: currentUserManuName('/booking/index') || ReservaExpressaMenuLabel,
}

const DetalhesDaReservaMenuLabel = 'Detalhes de Reserva Expressa'
const DetalhesDaReservaMenu = {
  path: '/booking-details/:booking_id',
  component: DetalhesdaReserva,
  name: currentUserManuName('/booking-details/:booking_id/index') || DetalhesDaReservaMenuLabel,
}

const TrafxMenuLabel = 'Trafx'
const TrafxMenu = {
  path: '/trafx',
  name: currentUserManuName('/trafx/index') || TrafxMenuLabel,
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  redirect: '/trafx/index',
  children: [
    {
      path: 'index',
      name: 'Trafx Index',
      component: Trafx
    }
  ]
}

const AgentSelectorMenu = {
  path: '/selectagent',
  component: AgentSelector,
  // redirect: "/selectagent",
  name: 'AgentSelector'
  // children: [
  //   {
  //     path: "index",
  //     name: "agents-menu",
  //     component: Agents
  //   }
  // ]
}

const CondutorMenu = {
  path: '/condutor/:uuid',
  alias: '/profile/:uuid',
  component: AgentLoader,
  name: 'CondutorMenu'
}

const ReportsMenu = {
  path: '/reports',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  redirect: '/reposts/sales',
  name: 'ReportsMenu',
  children: [
    {
      path: 'sales',
      name: 'Reports SalesReport',
      component: SalesReport
    },
    {
      path: 'visits',
      name: 'Visits Report',
      component: VisitsReport,
      props: { debug: false, reportMode: '' },
    },
    {
      path: 'visits/dashboard',
      name: 'Visits Report Dashboard',
      component: VisitsReport,
      props: { debug: true, reportMode: 'erp' },
    },
    {
      path: 'booking',
      name: 'Reports Booking',
      component: Booking
    }
  ]
}

// const TrafxMenu = {
//   path: '/trafx',
//   component: DashboardLayout,
//   beforeEnter: ifNotAuthenticated,
//   redirect: '/trafx/sales',
//   name: 'ReportsMenu',
//   children: [
//     {
//       path: 'sales',
//       name: 'Reports SalesReport',
//       component: SalesReport
//     },
//     {
//       path: 'visits',
//       name: 'Visits Report',
//       component: VisitsReport
//     },
//     {
//       path: 'booking',
//       name: 'Reports Booking',
//       component: Booking
//     }
//   ]
// }

const formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  redirect: '/forms/elements',
  name: 'Forms',
  children: [
    {
      path: 'elements',
      name: 'Form elements',
      component: FormElements
    },
    {
      path: 'components',
      name: 'Form components',
      component: FormComponents
    },
    {
      path: 'validation',
      name: 'Form validation',
      component: FormValidation
    }
  ]
}

const tablesMenu = {
  path: '/tables',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  redirect: '/table/regular',
  name: 'Tables menu',
  children: [
    {
      path: 'regular',
      name: 'Tables',
      component: RegularTables
    },
    {
      path: 'sortable',
      name: 'Sortable',
      component: SortableTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }
  ]
}

const mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  name: 'Maps',
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'vector',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

const pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  beforeEnter: ifNotAuthenticated,
  name: 'Pages',
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}

const authPages = {
  path: '/',
  beforeEnter: ifAuthenticated,
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: '/login',
      name: 'userLogin',
      component: userLogin
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password/:email_encoded',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/register',
      name: 'userRegister',
      component: userRegister
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    {
      path: '/lock',
      name: 'Lock',
      component: Lock
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
}

const routes = [
  // {
  //   path: "/login",
  //   name: "userLogin",
  //   component: userLogin,
  // },
  {
    path: '/logout',
    name: 'userLogout',
    component: userLogout
  },
  // {
  //   path: '/booking-details',
  //   name: 'Detalhes da Reserva',
  //   component: DetalhesdaReserva,
  // },
  {
    path: '/loading',
    component: IndexPage,
    name: 'Loading'
  },
  IssuesMenu,
  DashboardBocapioMenu,
  ProductsMenu,
  FinancialMenu,
  ClientsMenu,
  ClientServiceMonitorMenu,
  AgentsMenu,
  NotaFiscalMenu,
  OperationMenu,
  ReportsMenu,
  ConfigurationsMenu,
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  CondutorMenu,
  AgentSelectorMenu,
  ReservaExpressaMenu,
  DetalhesDaReservaMenu,
  TrafxMenu,
  pagesMenu,
  {
    path: '/',
    // component: DashboardLayout,
    // redirect: "/dashboardUser",
    // name: "Dashboard layout",
    redirect: '/loading',
    name: 'Loading From Home',
    children: [
      {
        path: 'dashboard',
        name: 'DashboardTemplete',
        component: DashboardTemplete // alterado de Dashboard para DashboardTemplete
      },
      {
        path: 'alternative',
        name: 'Alternative',
        component: AlternativeDashboard,
        meta: {
          navbarType: 'light'
        }
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      }
    ]
  },
  authPages
]

/**
 * Uses a path to find the route name for the current user
 *
 * @param {String} path route path (e.g. /agents/index)
 * @returns
 */
function currentUserManuName(path) {
  path = path.split('/')
  let controller = path[1]
  let action = path[2] ? path[2] : ''
  try {
    let userRole = (JSON.parse(sessionStorage.getItem("vuex")).auth.roles[controller]).find(role => role.action == action)
    return userRole.name
  } catch (error) {
    return false
  }
}
export default routes
